<a (click)="navigateToAppCurrentProject()">
    <div class="container" [style.backgroundImage]="'url(' + projectLogo + ')'">
        <div class="texts">
            <span class="app-name">{{projectName}}</span>
            <span class="app-desc">{{projectContent}}</span>
        </div>
    </div>
</a>
